import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { SERVER_URL } from "../../constant";
import AlertBox from "../../component/AlertBox";
import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import ButtonCompo from "../../component/ButtonCompo";
import PaginationBar from "../../component/PaginationBar";
import InputField from "../../component/InputField";

function FinalRoundShortlisted() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeDataForAccess = useSelector(
    (state) => state.employee?.employeeData
  );

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeDataForAccess !== null &&
      employeeDataForAccess?.admin?.talentAquisation === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeDataForAccess]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [reload, setReload] = useState(false);
  const [applicantData, setApplicantData] = useState([]);
  const [search, setSearch] = useState("");

  // fetch applicants
  async function getApplicants() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/talent/aquisation/final/round/shortlisted/applicants/${page}?search=${search}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setTotalPages(res.data?.data?.totalPages || 0);
      setApplicantData(res.data?.data?.data || []);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Applicants fetch failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getApplicants();
  }, [reload, page]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Shortlisted Applicants
          </h1>
          <div className="w-full mt-5">
            {applicantData?.length === 0 ? (
              <div>
                <p className="mt-0 text-slate-500 text-center p-7 font-semibold">
                  No applicant added yet
                </p>
              </div>
            ) : (
              <div className="w-full mt-0">
                <div className="w-full flex mb-5 justify-end">
                  <div className="flex items-center gap-5">
                    <InputField label="Search" size="small" onChange={eve => setSearch(eve?.target?.value)} />
                    <ButtonCompo variant={"contained"} onClick={() => setReload(prev => !prev)}>Search</ButtonCompo>
                  </div>
                </div>
                <Table>
                  <TableHead>
                    <TableRow className="bg-blue-500">
                      <TableCell className="!text-center !text-white">
                        SL No
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Applicant Name
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Applied For
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Email ID
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Phone Number
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Status
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Uploaded At
                      </TableCell>
                      <TableCell className="!text-center !text-white">
                        Details
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody className="border">
                    {applicantData.map((item, index) => (
                      <TableRow key={item?._id}>
                        <TableCell className="!text-center">
                          {index + 1}
                        </TableCell>
                        <TableCell className="!text-center">
                          {item?.applicantName}
                        </TableCell>
                        <TableCell className="!text-center">
                          <Link
                            to={`/admin/hiring/req/single/request/${item?.hiringReqId}`}
                            className="text-blue-600 font-medium hover:underline"
                          >
                            {item?.appliedPosition}({item?.appliedRole})
                          </Link>
                        </TableCell>
                        <TableCell className="!text-center">
                          {item?.applicantEmail}
                        </TableCell>
                        <TableCell className="!text-center">
                          {item?.applicantPhone}
                        </TableCell>
                        <TableCell className="!text-center">
                          {item?.finalStatus}
                        </TableCell>
                        <TableCell className="!text-center">
                          {new Date(item?.createdAt).toLocaleDateString(
                            "en-In"
                          )}
                        </TableCell>
                        <TableCell className="!text-center">
                          <ButtonCompo
                            onClick={() =>
                              navigate(
                                `/admin/talent/aquisation/single/job/applicant/${item?.applicantId}`
                              )
                            }
                            variant={"outlined"}
                          >
                            View
                          </ButtonCompo>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <PaginationBar
                  attendancePage={page}
                  setAttendancePage={setPage}
                  totalAttendancePage={totalPages}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default FinalRoundShortlisted;